import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  apply({currentTarget}) {
    const json = currentTarget.getAttribute("data-fields")
    if (!json) return

    const fields = JSON.parse(json)
    for (const [name, value] of Object.entries(fields)) {
      const input = this.element.querySelector(`[name="manager[${name}]"]`)
      if (!input) continue
      input.value = value
      input.dispatchEvent(new Event("input", {bubbles: true}))
      input.dispatchEvent(new Event("change", {bubbles: true}))
    }
  }
}
